/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedCommonModule } from "../../common/shared.common.module";
import { UsbComponent } from "./usb.component";

@NgModule({
   imports: [CommonModule, SharedCommonModule],
   declarations: [UsbComponent],
   exports: [UsbComponent]
})
export class UsbRedirectionModule {}
